export default {
  buttons: {
    reschedule: 'Lên lịch lại',
    'reschedule-change-address': 'Lên lịch lại/Thay đổi địa chỉ',
    'add-time': 'Thêm thời gian',
  },
  'pickup-time-min-title': 'Thời gian lấy hàng tối thiểu',
  'pickup-time-max-title': 'Thời gian lấy hàng tối đa',
  'pickup-date': 'Chọn ngày giao hàng',
  'change-address': {
    title: 'Bạn đã thay đổi địa chỉ',
    description: 'Vui lòng cho chúng tôi chút thời gian để xử lý đơn hàng của bạn, chúng tôi sẽ cung cấp liên kết theo dõi.',
    error: 'Xin lỗi, chúng tôi không giao tới địa chỉ này, vui lòng nhập địa chỉ khác',
  },
  'coolbox-modal': {
    message: 'Thuốc của bạn có hạn chế giao hàng theo thời gian.<br>Bạn có chắc muốn lên lịch lại ngày giao không?',
    rescheduleButton: 'Đồng ý, lên lịch lại',
    cancelButton: 'Hủy',
  },
  'next-day-window': 'Ngày hôm sau 8:00am-9:00pm',
}
